import React from "react";
import styled from "styled-components";
import CommonActionButton from "./CommonActionButton";
import { CommonActionBarProps } from "./types";

const ActionBarContainer = styled.div`
  display: flex;
  padding: 16px 32px;
  justify-content: space-between;
`;

const LeftActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const CommonActionBar: React.FC<CommonActionBarProps> = ({
  leftActions,
  rightActions,
}) => {
  return (
    <ActionBarContainer>
      <LeftActionContainer>
        {leftActions.map((action) => (
          <CommonActionButton key={action.type} {...action} />
        ))}
      </LeftActionContainer>
      {rightActions.map((action) => (
        <CommonActionButton key={action.type} {...action} />
      ))}
    </ActionBarContainer>
  );
};

export default CommonActionBar;
